const configs = {
  development: {
    apiUrl: "https://blueparking.dev",
  },
  test: {
    apiUrl: "https://blueparking.dev",
  },
  production: {
    apiUrl: "https://blueparking.dev",
  },
};

const env = process.env.REACT_APP_ENV || "development";

export default configs[env] || configs.development;
